// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"378c4d66","452":"2a62f820","580":"78655c70","599":"79d4a1d9"}[chunkId] + ".chunk.js";
};